import Layout           from './pods/components/layout/layout';
import RegistrationForm from './pods/components/registration-form/registrationForm';
import checkMaintenanceMode from './maintenanceUtil';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

function App() {
  const RECAPTCHA_KEY = '6LcpxZQrAAAAAPPR6DO097sxlsZ3-V38dwNSlcLD';
  checkMaintenanceMode();
  return (
    <>
      <Layout>
        <Layout.Nav/>
        <Layout.Body>
          <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY}>
            <RegistrationForm/>
          </GoogleReCaptchaProvider>
        </Layout.Body>
      </Layout>
    </>
  );
}

export default App;
